import React from 'react'
import { Set } from 'immutable'
import AttributedHtmlText from '#src/components/AttributedHtmlText'
import { PlainInputSelectable, Group } from '#src/components/Path/components/Selectable'
import { ListPathFlowQuestionProps } from '../'
import styles from '#src/components/Path/components/ListPathFlowQuestion/MultiSelect/styles.css'

const MultiSelectPillsQuestion: React.SFC<ListPathFlowQuestionProps> = ({
  question,
  onFieldValueChanged,
  onFieldValidityChanged,
  className,
  animationDelay,
  style
}) => {
  const defaultValues = question.listUserInput.value ? Set(question.listUserInput.value) : Set()

  return (
    <div className={styles.grid}>
      <Group
        name={question.internalName}
        key={question.internalName}
        onSelect={values => {
          //@ts-ignore TODO: Fix this Set<value> to Array translation, this isn't support by typescript
          onFieldValueChanged({ value: [...values] })
        }}
        multiple={true}
        defaultValues={defaultValues}
        onValid={() => onFieldValidityChanged(true)}
        onInvalid={() => onFieldValidityChanged(false)}
      >
        {question.choices.map((choice, index) => {
          const headline = choice.text ? <AttributedHtmlText text={choice.text} /> : ''

          return (
            <PlainInputSelectable
              key={choice.value}
              value={choice.value}
              classes={{
                default: styles.pill,
                selected: styles.selected
              }}
              className={className}
              style={{ ...style, animationDelay: `${animationDelay * (index! + 1)}s` }}
            >
              {headline}
            </PlainInputSelectable>
          )
        })}
      </Group>
    </div>
  )
}

export default MultiSelectPillsQuestion
